import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Message } from 'antd';
import { fetchOCR } from '../../api/demonstration';
import FunctionDemonstration from './FunctionDemonstration';
import account from '@/common/account/index';

const OcrPtrDemonstration = ({ materialsPath, selectList }) => {
  const [result, setResult] = useState([]);
  const [response, setReponse] = useState(null);
  const [request] = useState({
    Params: {
      sid: '请求标识',
      URL: '图片的URL地址',
      imagedata: '图片的Base64编码',
      imageLength: '图片的Base64编码的长度'
    }
  });

  function getBase64Image(img) {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, img.width, img.height);
    const ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase();
    const dataURL = canvas.toDataURL(`image/${ext}`);
    return dataURL;
  }

  const analysisImg = (imgBase64, param, isUrl = false) => {
    let userId = null;
    const loginEd = account.hasLoggedin();
    if (loginEd) userId = localStorage.getItem('userId') || null;
    const img = imgBase64.replace(/\S*base64,/, '');
    const ocrParams = {
      idx: '10000',
      sid: new Date().getTime().toString(),
      openMode: param,
      platform: '1',
      method: '/aiocr/srchsub',
      userId
    };
    if (isUrl) {
      ocrParams.URL = imgBase64;
      ocrParams.imageLength = 0;
    } else {
      ocrParams.imageLength = img.length;
      ocrParams.imagedata = imgBase64.replace(/\S*base64,/, '');
    }
    fetchOCR(ocrParams)
      .then((data) => {
        setReponse(data);
        if (data.code === 20001) {
          setResult(data.data.content);
        }
      })
      .catch((err) => {
        Message.error(err.msg || err.message);
        setReponse({});
        // console.log(err);
      });
  };

  const handleImgurlToBase64 = (imgurl, param) => {
    const image = new Image();
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = imgurl;
    image.onload = () => {
      const imgBase64 = getBase64Image(image);
      analysisImg(imgBase64, param);
    };
  };

  const identifyingImg = (imgurl, imgBase64, param) => {
    if (imgurl) {
      // handleImgurlToBase64(imgurl, param);
      analysisImg(imgurl, param, true);
    } else if (imgBase64) {
      analysisImg(imgBase64, param, false);
    }
  };

  return (
    <FunctionDemonstration
      result={
        <ul>
          <li className="result_text">
            <span>{result}</span>
          </li>
        </ul>
      }
      response={response}
      request={request}
      handleIdentifyingImg={identifyingImg}
      materialsPath={materialsPath}
      selectList={selectList}
    />
  );
};

OcrPtrDemonstration.propTypes = {
  data: PropTypes.shape({
    materialsPath: PropTypes.array,
    selectList: PropTypes.array
  })
};

export default OcrPtrDemonstration;
